<div
  #cm
  [id]="'cm-' + id"
  class="ladder-blotter-columnselector-container"
  [hidden]="!show"
  (contextmenu)="hideMenu()"
  [style.left.px]="position.x"
  [style.top.px]="position.y"
  [@showHideMenu]="show ? 'show' : 'hide'"
  (@showHideMenu.start)="showHideMenuStarted($event,cm)"
>
  <table>
    <tbody>
      <tr *ngFor="let row of gridColumnDef">
        <td *ngFor="let colDef of row" [ngClass]="{'spacing-table-rows': isNativeDesktop}">
          <bfx-checkbox-icon-small
            [disabled]="colDef.disableInPicker"
            label="{{colDef.colSelectorName != null ? colDef.colSelectorName : colDef.headerName}}"
            title="{{colDef.colSelectorName != null ? colDef.headerName : ''}}"
            [checked]="!colDef.hide"
            (click)="columnSelected($event, colDef)"
          ></bfx-checkbox-icon-small>
        </td>
      </tr>
    </tbody>
  </table>
</div>
